import { useSettings, useStore } from '../context/store';
import Moment from 'moment';


export default function useGetPosts() {
	const { state, dispatch } = useStore();

	const settings = useSettings();

	const getRequestUrl = function (perPage, replace) {
		let url = `${WP.siteUrl}/wp-json/trip-finder/search?`;
		// Templates supply the page URL; fall back to the current path so a template that
		// omits it still loads results instead of throwing.
		const pageUrl =
			document.querySelector( '.trip-url' )?.getAttribute( 'data-page-url' ) ||
			window.location.pathname;
		let displayUrl = pageUrl + '?';

		if (state.searchQuery.length) {
			url += `s=${encodeURIComponent(state.searchQuery)}&`;
		}

		for (const taxonomy in state.selectedTaxonomies) {
			const removeIndex = state.selectedTaxonomies[taxonomy].map(
				(term) => {
					if (term.toString().indexOf('-') > -1) {
						// console.log('term ', term);
						return parseInt(term.split('-')[0]);
					}
					return parseInt(term);
				}
			);

			if( removeIndex[0] !== false ) {
				// console.log('was true');
				url += `tax[${encodeURIComponent(taxonomy)}]=${removeIndex.join(
					','
				)}&`;
				displayUrl += `selectedTaxonomies[${encodeURIComponent(taxonomy)}]=${removeIndex.join(
					','
				)}&`;
			}
		}

		if (null !== state.selectedStartDate) {
			url += `departure_start=${new Date(state.selectedStartDate.format('MM/DD/Y') + ' UTC').getTime() / 1000}&`;
			displayUrl += `departure_start=${Moment(state.selectedStartDate).format('L')}&`;
		}

		if (null !== state.selectedEndDate) {
			url += `departure_end=${new Date(state.selectedEndDate.format('MM/DD/Y') + ' UTC').getTime() / 1000 + 86399}&`;
			displayUrl += `departure_end=${ Moment(state.selectedEndDate).format('L')}&`;
		}

		if (null !== state.sortBy) {
			url += `sort_by=${state.sortBy}&`;
			displayUrl += `sort_by=${state.sortBy}&`;
		}

		if (null !== state.searchText) {
			url += `searchQuery=${state.searchText}&`;
			displayUrl += `searchQuery=${state.searchText}&`;
		}

		url += `per_page=${perPage}`;
		
		if (!replace) {
			url += `&page=${state.currentPage}`;
		}
		
		// if (state.sortBy.length) {
		// 	url += `&sort=${state.sortBy}`;
		// }
		window.history.replaceState('trips', null, displayUrl);

		return url;
	};

	const getPosts = async function (perPage = 18, replace = true) {
		const url = getRequestUrl(perPage, replace);
		console.log('url ', url);

		dispatch({ type: 'setLoading', payload: true });

		const response = await fetch(url);
		const data = await response.json();

		// console.log('post data ', data);

		if (!replace) {
			data.records = state.posts.concat(data.records);
		} else {
			dispatch({ type: 'setCurrentPage', payload: 1 });
		}

		dispatch({ type: 'setSearchResults', payload: data });
		dispatch({ type: 'setLoading', payload: false });
	};

	return {
		getPosts,
	};
}
